<template>
  <div>
    <b-row>
      <b-col
          cols="12"
          md="8"
      >
        <b-card title="Masaüstü Görsel">
          <b-img
              v-if="dataItem.image"
              :src="imageUrl + '/media/carousel/' + dataItem.image"
              thumbnail
              center
          />
          <div class="text-center mt-1">
            <b-button
                variant="primary"
                @click="setModal('carousel',cropperSettings.fileName)"
            >
              <FeatherIcon icon="UploadIcon" />
              Görsel Yükle
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col
          cols="12"
          md="4"
      >
        <b-card title="Mobil Görsel">
          <b-img
              v-if="dataItem.image_mobile"
              :src="imageUrl + '/media/carousel/' + dataItem.image_mobile"
              thumbnail
              center
          />
          <div class="text-center mt-1">
            <b-button
                variant="primary"
                @click="setModal('carouselMobile',cropperSettings.fileName)"
            >
              <FeatherIcon icon="UploadIcon" />
              Görsel Yükle
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        :width-size="cropperSettings.widthSize"
        :component="cropperSettings.type === 'carousel'? 'carousel' : 'carouselMobile'"
        :params="cropperSettings.type"
        :item-id="dataItem.id"
        @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton,BRow, BCol } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ImageCardWebp',
  components: {
    BCard,
    BImg,
    BButton,
    BRow, BCol,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['carousel/dataItem']
    },
  },
  methods: {
    setModal(type, file) {
      const fileNamee = file?.name
      if (type === 'carousel') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: fileNamee,
          folder: 'carousel',
          ratio: 1920 / 'auto',
          widthSize: 1920,
          type: 'carousel',
        }
      }
      if (type === 'carouselMobile') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: fileNamee,
          folder: 'carousel',
          ratio: 2 / 3,
          widthSize: 500,
          type: 'carouselMobile',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'carousel') {
        this.dataItem.image = item.filename
        this.dataItem.thumb = item.thumb
        this.dataItem.image_webp = item.filename_webp
        this.dataItem.thumb_webp = item.thumb_webp
      }
      if (this.cropperSettings.type === 'carouselMobile') {
        this.dataItem.image = item.filename
        this.dataItem.thumb = item.thumb
        this.dataItem.image_webp = item.filename_webp
        this.dataItem.thumb_webp = item.thumb_webp
      }
      this.dataItem.mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
